import React, { useState } from 'react';
import './Temporadas.css';
import { actualizarJugadorReal } from '../../services/jugadoresService';

// Edita el nombre completo y el alias de un jugador del catálogo global. Se
// guarda al momento (PATCH /jugadores/:id), no forma parte del borrador de
// ninguna pantalla. En los partidos se muestra el alias si lo tiene; vacío =
// sin alias.
export default function ModalEditarJugador({ jugador, onGuardado, onCerrar }) {
  const [nombre, setNombre] = useState(jugador.nombre ?? '');
  const [alias, setAlias] = useState(jugador.alias ?? '');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState(null);

  const guardar = async () => {
    const nombreLimpio = nombre.trim();
    const aliasLimpio = alias.trim() || null;
    if (!nombreLimpio) { setError('El nombre es obligatorio.'); return; }
    setGuardando(true);
    setError(null);
    try {
      await actualizarJugadorReal(jugador.id, { nombre: nombreLimpio, alias: aliasLimpio });
      await onGuardado({ id: jugador.id, nombre: nombreLimpio, alias: aliasLimpio });
      onCerrar();
    } catch (err) {
      setError(err.message || 'Error al guardar el jugador.');
      setGuardando(false);
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{ zIndex: 1100 }}
      onClick={(e) => e.target === e.currentTarget && !guardando && onCerrar()}
    >
      <div className="modal-box">
        <h3>Editar jugador</h3>
        {error && <p className="error-msg">{error}</p>}
        <div className="form-row">
          <label htmlFor="editar-jugador-nombre">Nombre completo</label>
          <input id="editar-jugador-nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} autoFocus />
        </div>
        <div className="form-row">
          <label htmlFor="editar-jugador-alias">Alias (opcional)</label>
          <input
            id="editar-jugador-alias"
            value={alias}
            onChange={(e) => setAlias(e.target.value)}
            placeholder="Si lo tiene, se verá en los partidos en vez del nombre completo"
          />
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCerrar} disabled={guardando}>Cancelar</button>
          <button className="btn btn-primary" onClick={guardar} disabled={guardando}>
            {guardando ? 'Guardando…' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}
